import Vue from 'vue'
import * as filters from '@/util/filter'

Object.keys(filters).forEach(filter => {
  Vue.filter(filter, filters[filter])
})
